<script>
import VMediaUploaderNotice from "../media/VMediaUploaderNotice";

export default {
  name: "VPhotoUploaderNotice",

  extends: VMediaUploaderNotice,
};
</script>